<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormMultiselect fieldName="dctcategory_id"
                                         label="Category"
                                         size="4"
                                         :options="select?.dct_knowledge_category"
                                         v-model:field="search.dctcategory_id" />

                        <FormInputText fieldName="knowledge_name"
                                       label="Knowledge name"
                                       size="4"
                                       :isFocus="true"
                                       v-model:field="search.knowledge_name" />

                        <FormCalendar fieldName="issue_date_from"
                                      label="Issue date from"
                                      size="2"
                                      hourFormat="24"
                                      dateFormat="yy-mm-dd"
                                      v-model:field="search.issue_date_from" />

                        <FormCalendar fieldName="issue_date_to"
                                      label="Issue date to"
                                      size="2"
                                      hourFormat="24"
                                      dateFormat="yy-mm-dd"
                                      v-model:field="search.issue_date_to" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormCalendar from '@crud/FormCalendar.vue'

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ['dct_knowledge_category'];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
